import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
  label: String,
  disabled: Boolean,
  fullWidth: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

const buttonClasses = computed(() => ({
  button: true,
  ["full-width"]: props.fullWidth,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(buttonClasses.value),
    disabled: __props.disabled
  }, _toDisplayString(__props.label), 11, _hoisted_1))
}
}

})